import {SymbolStates} from "./BasicSymbol";
import {Reel} from "../Reel";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {XwaysHoarder2Statics} from "../../XwaysHoarder2Statics";
import {XwaysHoarder2GameAssets} from "../../XwaysHoarder2GameAssets";
import {SimpleReelModelSymbolPosition} from "../../../core/reel/simplereel/SimpleReelModel";
import {BasicSymbol} from "./BasicSymbol";


export class DummySymbol extends BasicSymbol {

    constructor(symbolName: string, initState: SymbolStates, reel: Reel, symbolPosition: SimpleReelModelSymbolPosition) {

        super(symbolName, initState, reel, symbolPosition);

        this.load();
        this.isSticky = false;


    }

    public getStateAnimation(state: SymbolStates): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        this.isSticky = false;
        switch (state) {
            case SymbolStates.SPIN:
                break;
            case SymbolStates.LANDING:
                break;
            case SymbolStates.NO_WIN:
                break;
            case SymbolStates.WIN:
                break;
            case SymbolStates.REVEAL:
                break;
            case SymbolStates.REMOVED:
                break;
            case SymbolStates.WIN_TOGGLE:
                break;
            case SymbolStates.STICKY:
                break;
            case SymbolStates.START_SPIN:
                break;
            case SymbolStates.UNSTICKY:
                break;
            case SymbolStates.SPLIT:
                break;
            case SymbolStates.SCALED:  //only change sprite states
                break;
            default:

        }
        return tl;
    }


    public runNextSplit(text: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        return tl;
    }

    public playSpineAnimation(animName: string, loopCount: number): gsap.core.Timeline {
        const playTL: gsap.core.Timeline = gsap.timeline();
        //    this.view.addChild(this._ltSpine);
        return playTL;
    }

    public setSpriteTexture(textureName: string = ""): void {
        this.mainSprite.texture = PIXI.Texture.EMPTY;
        this.isSticky = false;
    }

    private load() {

        this.view = new PIXI.Container();
        this.view.name = `view_${this.symbolName}`;

        this.overlayContainer = new PIXI.Container();
        this.overlayContainer.name = "overlayContainer";

        this.mainSprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(XwaysHoarder2GameAssets.getSymbolStateTexturePath("L5", ""))[0]);
        this.mainSprite.name = "mainSprite";
        this.mainSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.mainSprite.anchor.set(0.5, 0.5);
        this.mainSpriteContainer.addChild(this.mainSprite);

        this.mainSpine = null;

        this.view.addChild(this.mainSpriteContainer);
        this.view.addChild(this.overlayContainer);

    }


}